var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.randomBackground,"id":"background"}})
}
var staticRenderFns = []

export { render, staticRenderFns }